const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';

export const getAuthKey = async (jwt: string) => {
  const response = await fetch(`${SERVER_URL}/board-chat/grant?token=${jwt}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response.ok) {
    const { authKey } = await response.json() as any;
    return authKey;
  } else {
    throw new Error(`Failed with status code: ${response.status}`);
  }
};
